export const data7_1_2 = [{
    name: 'Beginning 期初数',//名称
    name_code: "Beginning",//名称
    thisy_employee_num: 0,//Full Time 全职
    thisy_average_payroll: 0,//Trainee 实习生
    thisy_payroll_cost: 0,//FTE 全体员工
    lasty_employee_num: 0,//Full Time 全职
    lasty_average_payroll: 0,//Trainee 实习生
    lasty_payroll_cost: 0,//FTE 全体员工
    variance_emplyee_num: 0,//Full Time 全职
    ven_percent: 0,//% 百分比
    variance_average_payroll: 0,//名称
    vap_percent: 0,//名称
    variance_payroll: 0,//名称
    vp_percent: 0,//名称
    year_thisy_employee_num: 0,//名称
    year_thisy_average_payroll: 0,//名称
    year_thisy_payroll_cost: 0,//名称
    year_lasty_employee_num: 0,//名称
    year_lasty_average_payroll: 0,//名称
    year_lasty_payroll_cost: 0,//名称
    year_variance_emplyee_num: 0,//名称
    year_ven_percent: 0,//名称
    year_variance_average_payroll: 0,//名称
    year_vap_percent: 0,//名称
    year_variance_payroll: 0,//名称
}, {
    name: 'New Hires 新入职',
    name_code: "New_Hires",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Transfer In 内部转入',
    name_code: "Transfer_In",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Resignation 辞职',
    name_code: "Resignation",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Termination 终止',
    name_code: "Termination",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Retirement  退休',
    name_code: "Retirement",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Transfer Out 内部转出',
    name_code: "Transfer_Out",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'End 期末数',
    name_code: "End",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: '离职人数总计',
    name_code: "Movement",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}, {
    name: 'Turnover % 员工离职率',
    name_code: "Turnover",
    thisy_employee_num: 0,
    thisy_average_payroll: 0,
    thisy_payroll_cost: 0,
    lasty_employee_num: 0,
    lasty_average_payroll: 0,
    lasty_payroll_cost: 0,
    variance_emplyee_num: 0,
    ven_percent: 0,
    variance_average_payroll: 0,
    vap_percent: 0,
    variance_payroll: 0,
    vp_percent: 0,
    year_thisy_employee_num: 0,
    year_thisy_average_payroll: 0,
    year_thisy_payroll_cost: 0,
    year_lasty_employee_num: 0,
    year_lasty_average_payroll: 0,
    year_lasty_payroll_cost: 0,
    year_variance_emplyee_num: 0,
    year_ven_percent: 0,
    year_variance_average_payroll: 0,
    year_vap_percent: 0,
    year_variance_payroll: 0,
    year_vp_percent: 0,
}];


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-2/data.js